export const brands = [
    {
        label: 'Pokemon',
        value: 'pokemon'
    },
    {
        label: 'Nintendo',
        value: 'nintendo'
    },
    {
        label: 'WIXOSS',
        value: 'wixoss'
    },
    {
        label: 'Blizzard',
        value: 'blizzard'
    }
]

export const conditions = [
    {
        label: 'Brand New',
        value: 'brand_new'
    },
    {
        label: 'Like New',
        value: 'like_new'
    },
    {
        label: 'Good',
        value: 'good'
    },
    {
        label: 'Bad',
        value: 'bad'
    }
]

export const rarities = [
    {
        label: 'Common',
        value: 'common'
    },
    {
        label: 'Rare',
        value: 'rare'
    },
    {
        label: 'Ultra Rare',
        value: 'ultra_rare'
    },
    {
        label: 'Legendary',
        value: 'legendary'
    }
]



// Selling volume is no longer capped by plan -- every paid plan sells as much
// as it likes, and the plan only decides the transaction-fee ladder applied to
// each item's price (see utils/fees.js).
export const memberships = {
    'free': {
        price: 0
    },
    'basic': {
        price: 50,
        benefits: [
            'Unlimited listings and sales every month',
            'Tiered transaction fees: 8% down to 2% by item price',
            'Easily chat with buyers and sellers',
            'Withdraw earnings after a 7-day clearing period'
        ],
        priceId: 'price_1QjOlRPDvB341sj3I0zizg7P'
    },
    'pro': {
        price: 100,
        benefits: [
            'Unlimited listings and sales every month',
            'Transaction fees capped at 5%, down to 2% by item price',
            'Withdraw earnings after 3 days, not 7',
            'Priority support via email',
            'All features from Tier 1 included'
        ],
        priceId: 'price_1QjOmOPDvB341sj3PJZIPtdD'
    },
    'elite': {
        price: 250,
        benefits: [
            'Unlimited listings and sales every month',
            'Flat 2% transaction fee on every sale',
            'Withdraw earnings after 3 days, not 7',
            'Top-priority support via email',
            'All features from Tier 1-2 included'
        ],
        priceId: 'price_1QjOmmPDvB341sj3BScaUnFK'
    }
}

export const homeSliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    customPaging: function (i) {
        return (
            <div className="slick-dot w-[8px] lg:w-[10px] h-[8px] lg:h-[10px] cursor-pointer bg-white/30 backdrop-blur-sm"></div>
        );
    },
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 360,
            settings: {
                slidesToShow: 1
            }
        }
    ]
}

export const homeCategorySliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3.5,
    slidesToScroll: 1,
    arrows: false,
    customPaging: function (i) {
        return (
            <div className="slick-dot w-[8px] lg:w-[10px] h-[8px] lg:h-[10px] cursor-pointer bg-white/30 backdrop-blur-sm"></div>
        );
    },
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 360,
            settings: {
                slidesToShow: 1
            }
        }
    ]
}

export const subAdminPrivilege = {
    CATEGORY_MANAGER: 'Category Manager',
    BOX_TYPE_MANAGER: 'Box Type Manager',
    LISTING_MANGER: 'Listing Manager',
    SUPPORT_MANAGER: 'Support Manager',
}
export const subAdminPrivileges = [
    {
        label: 'Category Manager',
        value: subAdminPrivilege.CATEGORY_MANAGER
    },
    {
        label: 'Box Type Manager',
        value: subAdminPrivilege.BOX_TYPE_MANAGER
    },
    {
        label: 'Listing Manager',
        value: subAdminPrivilege.LISTING_MANGER
    },
    {
        label: 'Support Manager',
        value: subAdminPrivilege.SUPPORT_MANAGER
    }
]